<template>
  <div class="search">
    <div class="input-container">
      <div class="inputs">
        <div>
          <label for="input-search-name">Nom du praticien</label>
          <input
            @input="executeSearch()"
            v-model="state.query.name"
            id="input-search-name"
            type="text"
          />
        </div>
      </div>
      <div class="inputs">
        <label for="input-search-city">Ville</label>
        <input
          @focus="isFocus.city = true"
          v-model="state.query.city"
          id="input-search-city"
          type="text"
          autocomplete="off"
        />
        <ListCities
          v-if="isFocus.city === true"
          :dataLoaded="dataLoaded"
          @onClick="
            isFocus.city = false;
            executeSearch();
          "
        ></ListCities>
      </div>
    </div>
    <div>
      <button style="padding: 0.25rem" @click="initFilters()">
        Réinitialiser les filtres
      </button>
    </div>
  </div>
</template>

<script>
import { state, getData, getPositions } from "../store";
import Map from "../services/map";
import { reactive, ref, watch } from "vue";
import { getCity } from "../services/apiGouv";
import ListCities from "./ListCities.vue";

export default {
  name: "Search",
  components: { ListCities },

  setup() {
    const isFocus = reactive({
      inputCity: null,
    });

    const dataLoaded = ref(false);

    const isNullish = Object.values(state.query).every((value) => {
      return value === "";
    });

    if (isNullish) {
      state.displayedAnnuaire = state.listAnnuaire;
    }

    let timeoutId;

    const search = async () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(async () => {
        state.pagination.currentPage = 1;
        await Promise.all([
          getPositions(),
          getData(state.pagination.currentPage),
        ]);
        await Map.getMap();
        await Map.centerViewOnCity();
      }, 2000);
    };

    watch(
      () => state.query.city,
      async (value, oldValue) => {
        dataLoaded.value = false;
        await getCity(value);
        dataLoaded.value = true;
      }
    );

    const executeSearch = () => {
      search();
    };

    const initFilters = () => {
      state.query.name = "";
      state.query.city = "";
      search();
      Map.centerView();
    };

    return { dataLoaded, state, isFocus, executeSearch, initFilters };
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/_variables.scss";

.search {
  @include buttonStyle(#fff, none, $base-color);
  @include inputStyle;
  background-color: $base-color;
  padding: 1em;
  .input-container {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-wrap: wrap;
    .inputs {
      position: relative;
      label {
        color: #fff;
        display: block;
      }
      input {
        width: 400px;
      }
    }
  }

  div:last-child {
    text-align: center;
    margin-top: 2em;
  }
}
</style>
